webpackJsonp([131],{

/***/ "q6tK":
/***/ (function(module, exports) {

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var ButtonStart = (function () {
    function ButtonStart() {
        this.defaultButtons = [
            {
                title: 'signup-free',
                isLogin: false
            }, {
                title: 'create-video',
                isLogin: true
            }
        ];
    }
    ButtonStart.prototype.$onInit = function () {
        this.setButtons();
    };
    ButtonStart.prototype.setButtons = function () {
        if (!this.buttons) {
            return;
        }
        if (this.buttons === true) {
            this.buttons = this.defaultButtons;
        }
        var user = options.user;
        var getUrl = function (button) {
            var loginUrl = 'wave/video-templates';
            return button.isLogin ? loginUrl : 'wave/signup';
        };
        this.buttons = this.buttons.map(function (button) { return (__assign({}, button, { url: button.url || getUrl(button), show: user.anonymous && !button.isLogin || !user.anonymous && button.isLogin })); });
    };
    return ButtonStart;
}());
angular.module('animatronApp.buttonStart', []).component('buttonStart', {
    bindings: {
        additionalClasses: '@',
        buttons: '<'
    },
    controller: ButtonStart,
    template: "<a\n                class=\"{{ $ctrl.additionalClasses }}\"\n                ng-repeat=\"button in $ctrl.buttons\"\n                ng-href=\"{{ button.url }}\"\n                ng-if=\"button.show\"\n        >{{::$root.t(button.title)}}</a>"
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/131-257c10c0995a4d25fa59.min.js